import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../../svgIcon/SvgIcon';

export function LogoPrive(props) {
    return (
        <SvgIcon {...props}>
            <path
                fill="#EDA820"
                d="M194.63,8.118h-0.878c-1.597,0-4.837,0.423-6.521,1.187c-1.337,0.63-1.683,1.213-1.683,2.839v14.643
                    c0,0.496,0.318,0.829,0.793,0.829h1.79c0.475,0,0.795-0.333,0.795-0.829V11.782c1.765-0.422,3.54-0.603,5.881-0.603
                    c0.145,0,0.617-0.053,0.617-0.723v-1.51C195.424,8.335,194.996,8.118,194.63,8.118z"
            />
            <path
                fill="#EDA820"
                d="M229.729,5.889c0.159,0.159,0.318,0.193,0.423,0.193c0.087,0,0.231,0,0.423-0.128l4.73-3.434
                    c0.186-0.123,0.276-0.286,0.276-0.497c0-0.137-0.055-0.277-0.143-0.374l-1.067-1.374C234.237,0.072,234.027,0,233.875,0
                    c-0.133,0-0.224,0.019-0.393,0.131l-4.706,3.547c-0.147,0.111-0.297,0.26-0.297,0.521c0,0.214,0.125,0.392,0.18,0.443
                    L229.729,5.889z"
            />
            <path
                fill="#EDA820"
                d="M220.388,8.574h-2.072c-0.441,0-0.766,0.246-0.888,0.677l-4.434,15.725h-0.464L207.61,9.25
                    c-0.053-0.185-0.192-0.676-0.815-0.676h-2.214c-0.425,0-0.688,0.251-0.688,0.654c0,0.047,0,0.189,0.086,0.446l5.826,17.164
                    c0.146,0.479,0.539,0.776,1.028,0.776h3.688c0.455,0,0.854-0.313,0.99-0.771l5.583-17.346c0.073-0.217,0.042-0.434-0.085-0.611
                    C220.871,8.694,220.633,8.574,220.388,8.574z"
            />
            <path
                fill="#EDA820"
                d="M200.52,8.574h-1.722c-0.479,0-0.826,0.349-0.826,0.828v17.384c0,0.48,0.348,0.829,0.826,0.829h1.722
                    c0.48,0,0.829-0.349,0.829-0.829V9.402C201.349,8.923,201,8.574,200.52,8.574z"
            />
            <path
                fill="#EDA820"
                d="M238.737,11.395c-1.275-2.205-3.647-3.276-7.251-3.276c-7.036,0-8.449,3.824-8.449,9.994
                    c0,7.167,2.586,9.96,9.223,9.96c2.287,0,4.646-0.4,6.161-1.044c0.195-0.084,0.715-0.308,0.521-0.885l-0.391-1.383
                    c-0.133-0.403-0.4-0.488-0.601-0.488c-0.078,0-0.143,0.008-0.403,0.083l-0.061,0.018c-1.586,0.474-2.84,0.848-4.946,0.848
                    c-2.615,0-4.099-0.47-4.965-1.573c-0.684-0.847-0.985-1.858-1.018-3.443h12.586c0.34,0,0.758-0.417,0.758-0.757v-1.722
                    C239.902,15.591,239.764,13.168,238.737,11.395z M226.932,13.694c0.542-2.039,1.715-2.762,4.483-2.762
                    c2.797,0,3.98,0.723,4.522,2.764c0.322,1.188,0.4,2.399,0.438,3.554l-9.847,0.033C226.562,16.087,226.616,14.859,226.932,13.694z"
            />
            <path
                fill="#EDA820"
                d="M200.52,0.604h-1.722c-0.479,0-0.826,0.348-0.826,0.828v3.793c0,0.452,0.355,0.793,0.826,0.793h1.722
                    c0.473,0,0.829-0.341,0.829-0.793V1.432C201.349,0.951,201,0.604,200.52,0.604z"
            />
            <path
                fill="#EDA820"
                d="M174.748,8.118c-2.211,0-4.99,0.473-6.918,1.177c-1.936,0.696-2.025,1.503-2.025,2.987v21.95
                    c0,0.381,0.228,0.768,0.662,0.768h0.001c0.048,0,0.099-0.005,0.165-0.019l1.908-0.46c0.159-0.045,0.643-0.183,0.643-0.746v-4.601
                    v-1.639c1.463,0.353,2.971,0.536,4.65,0.536c6.316,0,8.557-2.606,8.557-9.96C182.391,11.942,181.111,8.118,174.748,8.118z
                     M169.184,11.774c0.846-0.227,3.176-0.771,4.825-0.771c3.047,0,4.897,0.483,4.897,7.179c0,5.383-1.241,7.109-5.106,7.109
                    c-2.227,0-3.929-0.375-4.616-0.584V11.774z"
            />
            <path
                fill={props.dark ? '353535' : '#FFFFFF'}
                d="M71.998,8.858c-1.173-0.645-2.917-0.959-5.331-0.96c-3.304,0.002-6.371,0.687-7.531,1.12
                c-0.263,0.083-0.542,0.311-0.547,0.697v0.085l0.325,1.643l0.009,0.031c0.102,0.334,0.38,0.484,0.634,0.484h0.001
                c0.082-0.004,0.146-0.02,0.205-0.035l0.549-0.127c1.439-0.361,3.615-0.905,6.044-0.905c1.473,0,2.463,0.128,3.128,0.409
                c1.077,0.407,1.084,1.104,1.095,2.257v1.725c-0.124-0.003-0.332-0.005-0.652-0.005c-1.189,0-3.529,0.056-5.829,0.424
                c-3.511,0.54-6.415,1.38-6.397,6.216c0.002,6.141,5.696,6.152,8.434,6.158l0,0c1.858,0,3.572-0.274,4.691-0.506
                c2.555-0.594,3.208-1.404,3.174-3.944V13.416C74.001,11.858,74.006,9.921,71.998,8.858 M70.596,24.63
                c-1.36,0.441-2.848,0.665-4.424,0.665v0.144l-0.002-0.144c-2.518-0.02-4.977-0.308-4.979-3.519
                c0.017-2.555,1.379-2.858,3.104-3.243l0.119-0.027c1.534-0.327,5.387-0.39,6.182-0.398V24.63z M102.466,13.416v10.209
                c0.035,2.54-0.617,3.351-3.173,3.944c-1.119,0.231-2.833,0.506-4.69,0.506h-0.001c-2.737-0.006-8.432-0.018-8.434-6.158
                c-0.018-4.836,2.887-5.676,6.396-6.216c2.301-0.368,4.64-0.424,5.829-0.424c0.321,0,0.53,0.002,0.653,0.005v-1.725
                c-0.011-1.152-0.018-1.85-1.095-2.257c-0.664-0.281-1.655-0.409-3.128-0.409c-2.429,0-4.604,0.544-6.043,0.905l-0.551,0.127
                c-0.059,0.016-0.122,0.031-0.204,0.035h-0.001c-0.254,0-0.532-0.15-0.634-0.484l-0.009-0.031l-0.324-1.643l-0.001-0.085
                c0.005-0.387,0.284-0.614,0.547-0.697c1.16-0.434,4.228-1.118,7.531-1.12c2.414,0.001,4.157,0.315,5.331,0.96
                C102.475,9.921,102.47,11.858,102.466,13.416 M99.064,18.107c-0.795,0.009-4.647,0.071-6.182,0.398l-0.12,0.027
                c-1.725,0.385-3.087,0.688-3.104,3.243c0.003,3.211,2.462,3.499,4.979,3.519l0.002,0.144v-0.144c1.576,0,3.063-0.224,4.424-0.665
                V18.107z M154.035,7.898c-7.931,0.011-8.603,5.223-8.61,10.106c0.008,4.866,0.68,10.06,8.61,10.07h0.002
                c7.924-0.011,8.6-5.19,8.611-10.071C162.64,12.896,161.968,7.909,154.035,7.898 M154.036,25.224
                c-4.811-0.021-5.052-2.49-5.085-7.219c0.033-4.753,0.273-7.234,5.084-7.256c4.812,0.021,5.053,2.503,5.086,7.254
                C159.088,22.733,158.847,25.202,154.036,25.224 M139.803,27.357l-0.207,0.052c-1.109,0.281-2.629,0.666-5.293,0.666l0,0h-0.006
                c-7.34-0.011-8.78-3.714-8.788-10.106c0.009-7.331,2.333-10.061,8.575-10.07c2.202,0,3.719,0.285,4.808,0.548l-0.007-5.904
                c-0.01-0.259,0.108-0.599,0.721-0.715l1.95-0.498h0.105c0.448,0.012,0.607,0.411,0.608,0.749v22.188
                C142.299,25.667,142.135,26.869,139.803,27.357 M138.887,11.289c-0.651-0.166-2.468-0.575-4.515-0.575
                c-3.758,0.035-5.334,1.056-5.373,7.291c0.044,6.849,2.083,7.218,5.407,7.254l0.002,0.144v-0.144c2.068,0,3.844-0.431,4.477-0.605
                L138.887,11.289z M121.366,27.612h-1.743c-0.468,0-0.819-0.354-0.821-0.82V13.629c-0.031-2.228-0.696-2.846-3.095-2.88
                c-2.712,0-5.458,0.681-6.363,0.928v15.115c-0.001,0.475-0.331,0.82-0.785,0.82h-1.779c-0.467,0-0.819-0.354-0.82-0.82V12.028
                c-0.025-1.367,0.103-2.312,2.046-2.94c1.861-0.643,5.423-1.188,7.776-1.189c4.483,0.006,6.398,1.624,6.404,5.41v13.483
                C122.186,27.259,121.833,27.612,121.366,27.612 M81.873,27.969L81.873,27.969c1.004-0.02,1.744-0.219,2.035-0.544
                c0.102-0.115,0.15-0.249,0.138-0.381c-0.008-0.108-0.008-0.108-0.282-1.396l-0.007-0.03c-0.06-0.337-0.3-0.49-0.497-0.49
                c-0.019,0-0.037,0.001-0.027,0.003c0,0-0.252-0.013-0.5-0.013h-0.003c-0.714-0.022-1.306-0.127-1.317-1.172V2.078
                c-0.002-0.365-0.222-0.739-0.644-0.749L80.645,1.33l-1.953,0.501c-0.333,0.033-0.68,0.271-0.664,0.71v21.476
                c0.003,2.544,1.368,3.947,3.844,3.952H81.873z M54.291,27.612H40.299c-0.467,0-0.819-0.354-0.82-0.82v-1.708
                c-0.01-0.419,0.125-0.605,0.382-0.925l11.137-12.947H40.086c-0.468-0.001-0.82-0.354-0.82-0.82v-1.21
                c0-0.467,0.353-0.819,0.82-0.82H54.22c0.467,0.001,0.819,0.354,0.82,0.82v1.744c0.007,0.314-0.103,0.581-0.354,0.862L43.521,24.762
                H54.29c0.468,0.001,0.82,0.354,0.821,0.82v1.21C55.11,27.259,54.758,27.612,54.291,27.612"
            />
            <path
                fill="#EDA820"
                d="M29.613,13.547c-2.297-2.818-5.508-5.554-9.714-8.021l-0.017-0.009C15.644,3.109,11.669,1.695,8.08,1.115
                C5.84,0.753,4.77,1.174,4.283,1.455C3.796,1.736,2.896,2.452,2.09,4.574C0.797,7.972,0.034,12.12,0,16.996v0.018
                c0.034,4.877,0.797,9.026,2.09,12.425c0.806,2.121,1.706,2.838,2.193,3.118C4.77,32.838,5.84,33.26,8.08,32.897
                c3.589-0.581,7.563-1.994,11.803-4.402l0.017-0.01c4.206-2.467,7.417-5.203,9.714-8.021c1.434-1.759,1.604-2.896,1.604-3.459
                C31.218,16.443,31.047,15.306,29.613,13.547z"
            />
        </SvgIcon>
    );
}

LogoPrive.defaultProps = {
    viewBox: '0 0 240 35',
    dark: false,
};

LogoPrive.propTypes = {
    dark: PropTypes.bool,
};

export default LogoPrive;
